import React from "react";

import CountdownCircle from "common/CountdownCircle";
import { redirect } from "lib/util";

export default () => {
    const doRedirect = () => {
        redirect("/");
    };

    return (
        <div className="app-summary__countdown">
            <CountdownCircle delayMS={8000} handleCountdownEnd={doRedirect} />
        </div>
    );
};
